<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    v-model="model.condutaEncaminhamento"
                    :validations="{ required: true }"
                    name="Conduta e/ou encaminhamento"
                >
                    <rkm-form-checkbox
                        v-for="conduta in condutas"
                        :key="conduta.id"
                        :value="conduta.id"
                        class="w-50 m-0"
                        :disabled="isDisabled(conduta.id)"
                    >
                        {{ conduta.descricao }}
                    </rkm-form-checkbox>

                    <rkm-col cols="12">
                        <rkm-area
                            title="Encaminhamento *"
                            no-margin-top
                        >
                            <rkm-form-checkbox
                                v-for="encaminhamento in encaminhamentos"
                                :key="encaminhamento.id"
                                :value="encaminhamento.id"
                                class="w-50 m-0"
                                :disabled="isDisabled(encaminhamento.id)"
                            >
                                {{ encaminhamento.descricao }}
                            </rkm-form-checkbox>
                        </rkm-area>
                    </rkm-col>
                </rkm-form-checkbox-group>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import condutaEncaminhamento from '@/enums/atencao-basica/atendimento-odontologico/condutaEncaminhamento'
import tipoConsulta from '@/enums/atencao-basica/atendimento-odontologico/tipoConsulta'

export default {
    data: () => ({
        enums: {
            condutaEncaminhamento,
            tipoConsulta
        },
        condutas: [
            {
                id: condutaEncaminhamento.ALTA_EPISODIO,
                descricao: 'Alta do episódio',
            },
            {
                id: condutaEncaminhamento.RETORNO_CONSULTA_AGENDADA,
                descricao: 'Retorno para Consulta Agendada',
            },
            {
                id: condutaEncaminhamento.AGENDAMENTO_OUTROS_PROFISSIONAIS,
                descricao: 'Agendamento para Outros Profissionais AB',
            },
            {
                id: condutaEncaminhamento.AGENDAMENTO_EMULTI,
                descricao: 'Agendamento para eMulti',
            },
            {
                id: condutaEncaminhamento.AGENDAMENTO_GRUPOS,
                descricao: 'Agendamento para Grupos',
            },
            {
                id: condutaEncaminhamento.TRATAMENTO_CONCLUIDO,
                descricao: 'Tratamento Concluído',
            },
        ],
        encaminhamentos: [
            {
                id: condutaEncaminhamento.ATENDIMENTO_PACIENTES_NECESSIDADES_ESPECIAIS,
                descricao: 'Atendimento à Pacientes com Necessidades Especiais',
            },
            {
                id: condutaEncaminhamento.CIRURGIA_BMF,
                descricao: 'Cirurgia BMF',
            },
            {
                id: condutaEncaminhamento.ENDODONTIA,
                descricao: 'Endodontia',
            },
            {
                id: condutaEncaminhamento.ESTOMATOLOGIA,
                descricao: 'Estomatologia',
            },
            {
                id: condutaEncaminhamento.IMPLANTODONTIA,
                descricao: 'Implantodontia',
            },
            {
                id: condutaEncaminhamento.ODONTOPEDIATRIA,
                descricao: 'Odontopediatria',
            },
            {
                id: condutaEncaminhamento.ORTODONTIA_ORTOPEDIA,
                descricao: 'Ortodontia/Ortopedia',
            },
            {
                id: condutaEncaminhamento.PERIDONTIA,
                descricao: 'Peridontia',
            },
            {
                id: condutaEncaminhamento.PROTESE_DENTARIA,
                descricao: 'Prótese Dentária',
            },
            {
                id: condutaEncaminhamento.RADIOLOGIA,
                descricao: 'Radiologia',
            },
            {
                id: condutaEncaminhamento.OUTROS,
                descricao: 'Outros',
            }
        ],
    }),
    computed: {
        validations() {
            return {}
        }
    },
    methods: {
        isDisabled(id) {
            if(this.model.exportacao) {
                return true
            }
            if(id == this.enums.condutaEncaminhamento.TRATAMENTO_CONCLUIDO) {
                if(this.model.atendimento.tipoConsultaId == this.enums.tipoConsulta.PRIMEIRA_CONSULTA ||this.model.atendimento.tipoConsultaId == this.enums.tipoConsulta.CONSULTA_RETORNO) {
                    return false
                }
                return true
            }
            if(id == this.enums.condutaEncaminhamento.ALTA_EPISODIO) {
                if(this.model.atendimento.tipoConsultaId == this.enums.tipoConsulta.CONSULTA_MANUTENCAO) {
                    return false
                }
                return true
            }
            return false
        }
    },
    props: {
        model: { type: Object, required: false }
    }
}
</script>
